import { z } from 'zod';
import { RecordMode } from '@/types/Base';

export const groupItemPrototypeSchema = z.object({
  id: z.string(),
  fullName: z.string().optional(),
  parentGroupItemId: z.string().optional(),
  materialId: z.string().optional(),
  materialName: z.string().optional(),
});

export const QSTQuestionnairePrototypeDataSchema = z.object({
  id: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean(),
  materialGroupItemId: z.string(),
  materialId: z.string().optional(),
  prototypeDataMaterialGroup: groupItemPrototypeSchema.optional(),
  condition: z.string().optional(),
  acceptedValue: z.string().optional(),
  recommendedValue: z.string().optional(),
  perfectValue: z.string().optional(),
  qstQuestionnairePrototypeId: z.string(),
  recordMode: z.nativeEnum(RecordMode).optional(),
});

export const getPrototypeForQuestionSchema = z.object({
  id: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean(),
  description: z.string(),
  qstQuestionId: z.string(),
  qstQuestionnairePrototypeData: z.array(QSTQuestionnairePrototypeDataSchema),
});

export type GetPrototypeForQuestionResponse = z.infer<typeof getPrototypeForQuestionSchema>;
